import React from "react";
import { animated, config, useSpring } from "react-spring";
import { useMedia, useSticky } from "../utils/hooks";
import Social from "./_SocialLinks";

export default function SideBox({ about, social }) {
    const isMobile = useMedia(["(max-width: 992px)"], [true], false);
    const [ref, sticky] = useSticky();

    const { top } = useSpring({
        top: sticky ? `1.5rem` : `5.5rem`,
        config: config.gentle,
    });

    return (
        <animated.div {...ref} className="sideBox" style={{ position: isMobile ? "static" : "fixed", top }}>
            <div className="card">
                <div className="card-body bg-primary text-center pt-5">
                    <div>
                        <img className="rounded-circle avatar" alt={about.fullName} src={about.avatar} />
                    </div>
                    <div className="mt-4">
                        <h1 className="fontHeading">{about.shortName}</h1>
                        <p className="fontRegular">{about.brief}</p>
                        <Social social={social} />
                    </div>
                </div>
                {about.download && (
                    <div className="card-footer p-4">
                        <a className="btn btn-default btn-block text-uppercase my-2" target="_blank" rel="noopener noreferrer" href={about.download}>
                            Download
                        </a>
                    </div>
                )}
            </div>
        </animated.div>
    );
}
